<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_ViewDetailedBusiness')"
      width="700px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <div class="form-row" style="flex-direction:row;max-width: 920px">
          <el-form
            label-width="100px"
            label-position="left"
            style="margin-right:10px"
          >
            <cargo-ag-grid
              ref="jobsList"
              :show-side-bar="false"
              :grid-options="options"
              :column-defs="column"
              :row-data="jobs"
              style="width: 100%;min-width: 180px"
              @gridReady="params=>{gridApi=params.api}"
            />
          </el-form>
        </div>
      </div>
      <div class="spacing" />
      <div class="triggers" align="right">
        <el-button no="close" type="primary" @click="cancel">
          {{ $t('common.btn.close') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'ShowJobDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    jobs: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      options: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        columnApi: null
      },
      dataRows: [],
      column: [
        {
          headerName: this.$t('queryJob.businessNumber'), colId: 'jobNo', field: 'jobNo', minWidth: 160
        },
        { headerName: this.$t('queryJob.customer'), field: 'customerId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 180
        },
        { headerName: this.$t('queryJob.businessType'), colId: 'lob', field: 'lob', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('queryJob.FLCLType'),
          colId: 'containerLoadType',
          field: 'containerLoadType',
          width: 180,
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
            }
          }
        }
      ]
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style scoped>

.spacing {
  padding-top: 20px;
}
</style>

